var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C11.744 15 11.488 14.9021 11.293 14.7071L7.29301 10.7071C6.90201 10.3161 6.90201 9.68401 7.29301 9.29301C7.68401 8.90201 8.31607 8.90201 8.70707 9.29301L12 12.586L15.293 9.29301C15.684 8.90201 16.3161 8.90201 16.7071 9.29301C17.0981 9.68401 17.0981 10.3161 16.7071 10.7071L12.7071 14.7071C12.5121 14.9021 12.256 15 12 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDownSmall);
export default __webpack_public_path__ + "static/media/angle-down-small.21b5d15c2046fa814626a021b4f9b2d2.svg";
export { ForwardRef as ReactComponent };